import React from 'react';
import { motion } from 'framer-motion';
import { DocumentTextIcon } from '@heroicons/react/24/outline';


const DocumentCard = ({ doc }) => {
  // Extract original filename from the stored filename (remove UUID prefix)
  const getOriginalFilename = (filename) => {
    if (!filename) return 'Unknown Document';
    // Remove UUID prefix and underscore
    const parts = filename.split('_');
    if (parts.length > 1) {
      return parts.slice(1).join('_');
    }
    return filename;
  };

  return (
    <motion.div
      className="backdrop-blur-xl bg-white/30 rounded-2xl relative group border border-white/20 hover:border-indigo-200/50 hover:shadow-lg transition-all duration-300 overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -2 }}
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 via-purple-500/5 to-pink-500/5 opacity-50" />

      {/* Content */}
      <div className="relative p-6">
        {/* Header with document icon and name */}
        <div className="flex items-center space-x-3 mb-4">
          <div className="p-2 bg-gradient-to-br from-indigo-500/10 to-purple-500/10 rounded-xl backdrop-blur-sm">
            <DocumentTextIcon className="h-5 w-5 text-indigo-600" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 truncate">
              {getOriginalFilename(doc.filename)}
            </h3>
            <p className="text-xs text-gray-500 mt-1">
              Uploaded {new Date(doc.uploadedAt).toLocaleDateString()}
            </p>
          </div>
        </div>

        {/* Status badges */}
        <div className="flex items-center space-x-2">
          {doc.verified && (
            <span className="text-xs px-3 py-1 bg-green-500/10 backdrop-blur-sm text-green-700 rounded-full flex items-center border border-green-200/20">
              <DocumentTextIcon className="h-3 w-3 mr-1" />
              Verified
            </span>
          )}
          {!doc.verified && doc.status && (
            <span className="text-xs px-3 py-1 bg-yellow-500/10 backdrop-blur-sm text-yellow-700 rounded-full border border-yellow-200/20">
              {doc.status}
            </span>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default DocumentCard; 